import React from "react";
import AppBar from "../AppBar/AppBar";

import "./Page.scss";


const Page = (props) => {
  return (
    <div className={'page-logged-in'}>
      <header>
        <AppBar/>
      </header>
      <main>
        {props.children}
      </main>
    </div>
  );
};

export default Page;